<template>
  <div id="app">
    <easy-cron style="width: 700px;"  v-model="cronValue" @exeTime="updateTime"></easy-cron>
  </div>
</template>

<script>
import EasyCron from './components/easy-cron/index'

export default {
  name: 'App',
  components: {
    EasyCron
  },
  data () {
    return {
      exeStartTime: '',
      cronValue: ''
    }
  },
  methods: {
    showCron () {

      // console.log(this.realTime, this.cronValue)
    },
    updateTime (realTime) {
      const updateReal = () => {
        const {cronValue} = this
        const param = {
          realTime,
          cronValue
        }
        console.log(param)
        this.$parent.callback && this.$parent.callback(param)
      }
      updateReal()
    }
  }
}
</script>

<style>
html, body {
  width: 100%;
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue